import { render, staticRenderFns } from "./AnnouncementTable.vue?vue&type=template&id=2eb76128&scoped=true"
import script from "./AnnouncementTable.vue?vue&type=script&lang=js"
export * from "./AnnouncementTable.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementTable.vue?vue&type=style&index=0&id=2eb76128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb76128",
  null
  
)

export default component.exports